import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { clearCachedSession } from "./useOfflineSession";

const INACTIVITY_TIMEOUT_MS = 3 * 60 * 60 * 1000; // 3 heures

/**
 * Déconnecte l'utilisateur après 3h d'inactivité.
 * Écoute click, touchstart, keydown pour reset le timer.
 */
export function useInactivityLogout() {
  const navigate = useNavigate();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    function resetTimer() {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        clearCachedSession();
        navigate("/login", { replace: true });
      }, INACTIVITY_TIMEOUT_MS);
    }

    // Initialiser le timer
    resetTimer();

    // Événements d'activité
    const events: (keyof DocumentEventMap)[] = [
      "click",
      "touchstart",
      "keydown",
    ];
    for (const event of events) {
      document.addEventListener(event, resetTimer, { passive: true });
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      for (const event of events) {
        document.removeEventListener(event, resetTimer);
      }
    };
  }, [navigate]);
}
